import { handleActions } from 'redux-actions';
import actions from 'state/mrDistribution/ui/actionCreators';
import initialState from 'state/mrDistribution/ui/initial.state';

const ui = handleActions(
  {
    [actions.setFetching]: (state, { payload: { isFetching } }) => ({
      ...state,
      isFetching,
    }),
    [actions.setSubmitting]: (state, { payload: { isSubmitting } }) => ({
      ...state,
      isSubmitting,
    }),
  },
  initialState
);

export default ui;
